import * as api from '../api/justAppraised';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_DEED_PROCESSINGS = createRequestTypes(
  `${prefix}/FETCH_DEED_PROCESSINGS`,
);

export const FETCH_DEED_PROCESSING = createRequestTypes(
  `${prefix}/FETCH_DEED_PROCESSING`,
);

export const FETCH_DEED_PROCESSING_ERRORS = createRequestTypes(
  `${prefix}/FETCH_DEED_PROCESSING_ERRORS`,
);

export const FETCH_DEED_PROCESSING_LOG_TYPES = createRequestTypes(
  `${prefix}/FETCH_DEED_PROCESSING_LOG_TYPES`,
);

export const fetchDeedProcessings = makeApiActionCreatorV3(
  api.fetchDeedProcessings,
  FETCH_DEED_PROCESSINGS[START],
  FETCH_DEED_PROCESSINGS[SUCCESS],
  FETCH_DEED_PROCESSINGS[ERROR],
);

export const fetchDeedProcessing = makeApiActionCreatorV3(
  api.fetchDeedProcessing,
  FETCH_DEED_PROCESSING[START],
  FETCH_DEED_PROCESSING[SUCCESS],
  FETCH_DEED_PROCESSING[ERROR],
);

export const fetchDeedProcessingErrors = makeApiActionCreatorV3(
  api.fetchDeedProcessingErrors,
  FETCH_DEED_PROCESSING_ERRORS[START],
  FETCH_DEED_PROCESSING_ERRORS[SUCCESS],
  FETCH_DEED_PROCESSING_ERRORS[ERROR],
);

export const fetchDeedProcessingLogtypes = makeApiActionCreatorV3(
  api.fetchDeedProcessingLogtypes,
  FETCH_DEED_PROCESSING_LOG_TYPES[START],
  FETCH_DEED_PROCESSING_LOG_TYPES[SUCCESS],
  FETCH_DEED_PROCESSING_LOG_TYPES[ERROR],
);
